module.exports = __webpack_public_path__ + "img/thumb_30.2ed1eff3.jpg";